import { render, staticRenderFns } from "./EmailReply.vue?vue&type=template&id=de5077cc&scoped=true"
import script from "./EmailReply.vue?vue&type=script&lang=js"
export * from "./EmailReply.vue?vue&type=script&lang=js"
import style0 from "./EmailReply.vue?vue&type=style&index=0&id=de5077cc&prod&lang=scss&scoped=true"
import style1 from "./EmailReply.vue?vue&type=style&index=1&id=de5077cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5077cc",
  null
  
)

export default component.exports